export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5910.a2e06e45.jpg";